// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".c-select[data-v-fa8997c0]{width:100%;height:40px}.c-select[data-v-fa8997c0] select{height:100%;font-size:inherit;border-radius:.9375rem;border-color:#a5a5a5}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
